/**
 * Request payload for replacements endpoint
 * Includes baggage item and basic claim info (flight date, provider)
 */
export class StockReplacementRequest {
  /**
   * Create a StockReplacementRequest
   * @param {BaggageItem} baggageItem - the baggage item details
   * @param {StockReplacementRequestClaimInfo} claim - basic claim info including flight date and provider
   */
  constructor (baggageItem, claim) {
    this.baggageItem = baggageItem
    this.claim = claim
  }

  get baggageItem () {
    return this._baggageItem
  }

  set baggageItem (value) {
    this._baggageItem = value
  }

  get claim () {
    return this._claim
  }

  set claim (value) {
    if (value && !(value instanceof StockReplacementRequestClaimInfo)) {
      throw new TypeError('claim is not an instance of StockReplacementRequestClaimInfo')
    }
    this._claim = value
  }

  toJSON () {
    return {
      baggageItem: this._baggageItem,
      claim: this._claim
    }
  }
}

/**
 * Minimal claim info for replacements endpoint
 * Can be extended in the future
 */
export class StockReplacementRequestClaimInfo {
  /**
   * Create a StockReplacementRequestClaimInfo
   * @param {number} flightDate - Flight date as unix epoch (milliseconds or seconds)
   * @param {number} claimProviderId - Claim provider ID
   */
  constructor (flightDate, claimProviderId) {
    this.flightDate = flightDate
    this.claimProviderId = claimProviderId
  }

  get flightDate () {
    return this._flightDate
  }

  set flightDate (value) {
    if (value) this._flightDate = Number(value)
    else this._flightDate = null
  }

  get claimProviderId () {
    return this._claimProviderId
  }

  set claimProviderId (value) {
    if (value) this._claimProviderId = Number(value)
    else this._claimProviderId = null
  }

  toJSON () {
    return {
      flightDate: this._flightDate,
      claimProviderId: this._claimProviderId
    }
  }
}
